import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Denominate"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 19.5H3V4.5H8.379L10.9395 7.0605L11.379 7.5H21V13.5H22.5V7.5C22.5 6.67157 21.8284 6 21 6H12L9.4395 3.4395C9.15826 3.15818 8.77679 3.00008 8.379 3H3C2.17157 3 1.5 3.67157 1.5 4.5V19.5C1.5 20.3284 2.17157 21 3 21H10.5V19.5ZM21 19.5C21 18.2574 19.9926 17.25 18.75 17.25H14.25C13.0074 17.25 12 18.2574 12 19.5V21H13.5V19.5C13.5 19.0858 13.8358 18.75 14.25 18.75H18.75C19.1642 18.75 19.5 19.0858 19.5 19.5V21H21V19.5ZM16.5 16.5C14.8431 16.5 13.5 15.1569 13.5 13.5C13.5 11.8431 14.8431 10.5 16.5 10.5C18.1569 10.5 19.5 11.8431 19.5 13.5C19.5 15.1569 18.1569 16.5 16.5 16.5ZM18 13.5C18 14.3284 17.3284 15 16.5 15C15.6716 15 15 14.3284 15 13.5C15 12.6716 15.6716 12 16.5 12C17.3284 12 18 12.6716 18 13.5ZM10.1895 10.5L11.25 11.5612L9.3105 13.5L11.25 15.4395L10.1895 16.5L8.25 14.5605L6.3105 16.5L5.25 15.4395L7.1895 13.5L5.25 11.5612L6.3105 10.5L8.25 12.4403L10.1895 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Denominate.vue"]]);
